/*global jQuery, $ */

$(() => {
  $('header nav ul li')
    .on('mouseenter', (e) => {
      $(e.currentTarget).children('.child').stop().slideDown();
    })
    .on('mouseleave', (e) => {
      $(e.currentTarget).children('.child').stop().slideUp();
    })
});
